import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { GridOptions, GridReadyEvent, GridSizeChangedEvent, RowSelectedEvent } from 'ag-grid-community';
import { MarketplaceOrderStatus } from 'src/app/gamification/command-center/models/marketplace-order.model';
import { GameParticipant } from 'src/AngularJS/Goals/Gamification/Models/game-history';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { cloneDeep } from 'lodash';
import { AgGridAngular } from 'ag-grid-angular';
import { getQualifier, isConnect3, isConnectAll } from 'src/app/gamification/command-center/models/games-player-breakdown';
import { IHGameStandardize } from 'src/app/gamification/command-center/models/games-parameter.model';

type ProductState = {
  [key in MarketplaceOrderStatus]: string;
}
const PRODUCT_STATES: ProductState = {  
  [MarketplaceOrderStatus.InTransit]: "In_Transit",
  [MarketplaceOrderStatus.ReadyForPickup]: "Ready_for_Pickup",
  [MarketplaceOrderStatus.Complete]: "Complete",
  [MarketplaceOrderStatus.Shipped]: "Shipped",
  [MarketplaceOrderStatus.Cancelled]: "Cancelled", 
  [MarketplaceOrderStatus.Created]:"Processing",
  [MarketplaceOrderStatus.Processing]: "Processing",
};

const validOrderStatus = [MarketplaceOrderStatus.Created, MarketplaceOrderStatus.Processing, MarketplaceOrderStatus.ReadyForPickup];

@Component({
  selector: 'cv-games-history-table',
  templateUrl: './games-history-table.component.html',
  styleUrls: ['./games-history-table.component.scss', '../../games-add-edit-components/games-configure-components/configure-eligibility-brackets/configure-eligibility-brackets.component.scss']
})

export class GamesHistoryTableComponent implements OnInit {
  @Input() participants: any[];
  @Input() enableSelection: boolean;
  @Input() selectAll: boolean;
  @Input() reversion: boolean;
  @Input() hGame: IHGameStandardize;
  @Output() selectedData: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() selectedColumns: EventEmitter<any[]> = new EventEmitter();
  @Output() sortModel: EventEmitter<any[]> = new EventEmitter();
  @Output() totalRow: EventEmitter<any[]> = new EventEmitter();
  @Output() participantsSorted: EventEmitter<GameParticipant[]> = new EventEmitter();
  @ViewChild('gamesHistoryTableGrid') agGrid: AgGridAngular;

  gs = null;
  metricFields = null;
  participant = null;
  metric = null;
  qualifier = null;
  results = null;
  rewards = null;
  selectedRows: any[] = [];
  grid: GridOptions;
  revertedCoins: number = 0;
  revertedXP: number = 0;
  prevReversionValue: boolean;

  // Bracket view
  isExpandedView: boolean = false;
  currentParticipant = null;

  constructor(
    private gamesService: GamesService,
    private metricFormatPipe: GenericMetricFormatterPipe,
    private agGridHelperService: AgGridHelperService
  ) { 
    this.gs = this.gamesService.data;
    $(document).on('cancelRevertSelection', this.cancelRowSelection);
  }

  ngOnInit(): void {
    this.setupGrid();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.agGrid && this.agGrid.api) {
      if (changes.participants != undefined && changes.participants.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());
        this.agGrid.api.setGridOption('rowData', changes.participants.currentValue);
        const sumPlayers = changes.participants.currentValue.reduce((sum, current) => sum + 1, 0);
        const sumCoins = changes.participants.currentValue.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
        const sumXP = changes.participants.currentValue.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
        const sumBadges = changes.participants.currentValue.reduce((sum, current) => sum + current.badges.length, 0);
        const sumCustomRewards = changes.participants.currentValue.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && !a.isReverted).length;
        const sumRevertCustomRewards = changes.participants.currentValue.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && a.isReverted).length;
        const revertedCustomRewards = sumRevertCustomRewards > 0 ? `(-${sumRevertCustomRewards})`: '';

        this.revertedCoins = changes.participants.currentValue.filter((a: any) => { return a.calculatedCoins < 0; }).reduce((sum, current) => sum + (current.calculatedCoins), 0);
        this.revertedXP = changes.participants.currentValue.filter((a: any) => { return a.calculatedXP < 0; }).reduce((sum, current) => sum + (current.calculatedXP), 0);

        const pinnedData = [{
          participants: this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + sumPlayers,
          calculatedCoins: sumCoins,
          calculatedXP: sumXP,
          badges: sumBadges,
          custom: `${sumCustomRewards} ${revertedCustomRewards} ${this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward')}`,
        }];
        
        this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);

        /// Ag Grid 30.0.0 switch from setSortModel to applyColumnState through the columnApi
        ///this.agGrid?.api?.setSortModel([{ colId: 'ParticipantName', sort: 'desc' }]);
        this.agGrid?.api?.applyColumnState({
          state: [{ colId: 'ParticipantName', sort: 'desc' }]
        });
        //this.agGrid.columnApi.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();
        this.agGrid?.api?.refreshCells({ force: true });

        this.agGrid?.api?.hideOverlay();
        if (this.participants.length > 0) {
          this.agGrid?.api?.refreshHeader();
        } else {
          this.agGrid?.api?.showNoRowsOverlay();
        }
      } else if (changes.enableSelection != undefined && changes.enableSelection.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', []);
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());

        if (!changes.enableSelection.currentValue) {
          this.cancelRowSelection();
        }

        this.agGrid?.columnApi?.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();
      } else if (changes.selectAll != undefined) {
        if (changes.selectAll.currentValue) {
          this.agGrid?.api?.selectAll();
        } else {
          this.cancelRowSelection();
        }
      } else if(changes.reversion != undefined && changes.reversion.currentValue != null) {
        if (changes.reversion.currentValue) {
            this.selectedData.emit(this.selectedRows);
        }

      } else {
        this.agGrid.api.showLoadingOverlay();
      }

      this.selectedColumns.emit(this.agGrid.api.getColumnState());
      const pinnedBottomRow = this.agGrid.api.getPinnedBottomRow(0);
      if (pinnedBottomRow && pinnedBottomRow.data) {
        this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
      }
  
    }
  }

  setupGrid(){
    //Create grid options
    this.grid = {
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
      },

      accentedSort: true,
      animateRows: true,
      masterDetail: true,
      suppressCellFocus: true,
      suppressDragLeaveHidesColumns: true,
      suppressScrollOnNewData: true,
      suppressRowTransform: true,
      rowSelection: 'multiple',

      columnDefs: this.getColDefs(),

      isRowSelectable: (rowNode) => {
        if(!rowNode || !rowNode.data) return false;
        const hasPrize = (rowNode.data.calculatedCoins > 0 || rowNode.data.calculatedXP > 0);
        const hasValidStatus = rowNode.data.custom?.length > 0 && rowNode.data.productState != undefined && validOrderStatus.includes(rowNode.data.productState);
        // Row is selectable if is not reverted and if has a prize or if is a custom prize with a valid order status (processing, ready for pickup)
        return !rowNode.data.isReverted && (hasPrize || hasValidStatus);
      },

      getRowStyle: (params) => {
        if (params.node.rowPinned) {
          return { 'font-weight': 'bold' }
        }
      },

       // Sidebar will be included in the full version
      sideBar: {
        toolPanels: [{
          id: 'columns',
          labelDefault: this.gamesService.getGamesHistoryMessages('Columns', 'Columns'),
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
        }],
        defaultToolPanel: ''
      },

      components: {
        customLoadingOverlay: this.agGridHelperService.loadingOverlay,
      },

      rowData: null,
      loadingOverlayComponent: 'customLoadingOverlay',
      getLocaleText: this.agGridHelperService.getLocaleText,

      getRowId: (param: any) => {
        if (param.data && param.data.participant) { 
          return String(param.data.participant.LoginID);
        }
        return null;
      },

      onGridReady: (e: GridReadyEvent) => {

        if (this.participants) {
          this.setPinnedData(this.participants);
        } else {
          this.setPinnedData([]);
        }

        if (this.participants && this.participants.length > 0) {
          e.api.setGridOption('rowData', this.participants);
          e.api.autoSizeAllColumns();

          if (this.participants.length > 0) {
            e.api.hideOverlay();
          } else {
            this.grid.noRowsOverlayComponent = null;
            e.api.showNoRowsOverlay();
          }
        }
        if (!this.gs.isLoading && (!this.participants || this.participants.length == 0)) {
          if ((!this.gs.selectedInterval || this.gs.selectedInterval.length == 0) || (this.gs.selectedInterval || this.gs.selectedInterval.length > 0)) {
            this.agGrid?.api?.hideOverlay();
            this.agGrid?.api?.showNoRowsOverlay();
          }
        }
        if (this.agGrid?.columnApi) {
          this.updateSelectedColumns();
        }
        if (this.agGrid?.api && this.agGrid.api?.getPinnedBottomRow(0) && this.agGrid.api.getPinnedBottomRow(0).data) {
          this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
        }
      },

      onGridSizeChanged: (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
      },

      onRowSelected: (e: RowSelectedEvent) => {
        this.updateSelectedData(e);
      },
      
      onColumnMoved: () => {
        this.updateSelectedColumns();
      },

      onColumnVisible: () => {
          this.updateSelectedColumns();
      },

      onSortChanged: () => {
          this.updateSelectedColumns();
      },

      postSortRows: (X) => {
          let selectedRowNodesWithSort = [];
          this.agGrid.api.forEachNodeAfterFilterAndSort((node) => {
              selectedRowNodesWithSort.push(node.data );
          });
          
          this.participantsSorted.emit(cloneDeep(selectedRowNodesWithSort));
      },
    }
  }
  
  updateSelectedData(e: RowSelectedEvent): void {
    if (e.node.isSelected()) {
      this.selectedRows.push(e.node.data);
    } else {
      var index = this.selectedRows.indexOf(e.node.data);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  updateSelectedColumns(): void {
    this.selectedColumns.emit(this.agGrid.columnApi.getColumnState());
  }

  setNameColumnValue(params: any): any {
    if (params.data && typeof params.data === 'object' && !params.data.hasOwnProperty('participants')) {
      let $productContainer = $('<div>').addClass('d-flex');

      //Image profile
      let imageId = params.data && params.data.ImageID > 0 ? params.data.ImageID : "";
      let $img = null;
      const hasInvalidStatus = params.data.custom?.length > 0 && params.data?.productState != undefined && !validOrderStatus.includes(params.data.productState);

      //If the revert controls are enabled and the record payment can't be reverted, a left magin and padding are included to align this record with the others that have the checkbox input
      if (this.enableSelection && (params.data.isReverted || (params.data.calculatedCoins <= 0 && params.data.calculatedXP <= 0 && params.data.custom?.length <= 0) || hasInvalidStatus))
        $img = $('<img>').addClass('mr-2 ml-4 pl-1').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);
      else
        $img = $('<img>').addClass('mr-2').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);

      $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=${imageId}&w=auto&h=25`);
      $img.on('error', () => $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=&w=auto&h=26`));

      // Product name
      $('<span>').text(params.value).appendTo($productContainer)

      return $productContainer[0];
    } else {
        return params.data.participants;
    }
  }

  cancelRowSelection(): void {
    if (this.grid != null) {
      this.agGrid?.api?.deselectAll();
      this.selectedRows = [];
    }
  }

  getColDefs(): any {
    let resultsArray = [];

    let participant = {
      headerName: this.gamesService.getGamesHistoryMessages('Player', 'Player'),
      children: [{
        field: 'participant.LoginName',
        minWidth: 175,
        headerName: this.gamesService.getGamesHistoryMessages('Name', 'Name'),
        filter: 'agTextColumnFilter',
        checkboxSelection: this.enableSelection,
        cellRenderer: (params) => { return this.setNameColumnValue(params); }
      }]
    }
    resultsArray.push(participant);

    let joined = null;
    if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType != 10) {
      joined = {
        field: 'participant.AlreadyJoined',
        headerName: this.gamesService.getGamesHistoryMessages('Player_Joined', 'Joined?'),
        cellRenderer: (params) => {
          if (params.value === undefined || params.value === null)
            return '';

          var approve = ' ';
          if (this.gs.selectedGame.length > 0) {
            approve = params.value ? '<svg class="icon-16 fill-emeraldCity"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
          } else {
            approve = '--';
          }

          return approve;
        }
      };
      resultsArray.push(joined);
    }
      
    let metric = null;
    if (this.hGame && (isConnect3(this.hGame.GameType) || isConnectAll(this.hGame.GameType))) {
      const allMetrics = this.hGame.Connect3Definition;
      const connect3Metrics = [];
      for (let i = 0; i < allMetrics.length; i++) {
        const metric = allMetrics[i];
        const metricTemp = {
          headerValueGetter: params => {
            if (metric.MetricID != -1) {
              let metricString = metric.MetricDetail?.Abbrev || '';
              metricString += metric.MetricDetail?.DefaultMetricDirection === 0 ? "<" : ">";
              metricString += this.metricFormatPipe.transform(metric.LeftNumber, metric.MetricDetail?.ConversionType?.toString());
              return metricString;
            } else if (metric.MetricID == -1) {
              return this.gamesService.getLocalizedMessage(metric.MetricDetail?.Abbrev, 'Free Space');
            }
            return '--';
          },
          cellRenderer: (params) => {
            const metricsValues = params.data?.metricsValues;
            if (!(metricsValues)) {
              return '';
            }
            const metricValue = metricsValues.find(m => m.MetricID === metric.MetricID);
            if (metricValue && metric.MetricID != -1) {
              const condition = metric.MetricDetail?.DefaultMetricDirection === 0 ? metricValue?.MetricValue < metric.LeftNumber : metricValue?.MetricValue > metric.LeftNumber;
              const mark = condition ? '<svg class="icon-16 fill-emeraldCity ml-3"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder ml-3"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
              return metricValue ? `${metricValue.MetricDisplayValue} ${mark}` : '';
            } else if (metric.MetricID == -1) {
              return '<svg class="icon-16 fill-emeraldCity ml-3"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>';
            } else {
              return '';
            }
          },
          columnGroupShow: i != 0 ? 'open': false,
        }
        connect3Metrics.push(metricTemp);
      }

      metric = {
        headerName: this.gamesService.getGamesHistoryMessages('Metric_Total', 'Metric Total'),
        children: connect3Metrics,
      };
    } else if (this.hGame) {
      const metricDetail = this.hGame.metricDefinition;

      metric = {
        headerName: this.gamesService.getGamesHistoryMessages('Metric_Total', 'Metric Total'),
        children: [{
          field: 'metric',
          headerValueGetter: params => {
            if (metricDetail) {
              return metricDetail.MetricDetail?.Name;
            }
            return '--';
          },
          cellRenderer: (params) => {
            if (params.value != undefined && params.value != null) {
              return params.value;
            }
          },
        }]
      };
    }

    if (metric) resultsArray.push(metric);

    if (this.hGame && getQualifier(this.hGame)) {
      const qualifierMetric = getQualifier(this.hGame);

      let qualifier = {
        headerName: this.gamesService.getGamesHistoryMessages('Qualifier_Metric', 'Qualifier Metric'),
        children: [{
          field: 'qualifier',
          headerValueGetter: params => {
            if (qualifierMetric) {
              return qualifierMetric.MetricDetail ? qualifierMetric.MetricDetail.Name : this.gamesService.getGamesHistoryMessages('None', 'None');
            }
              return '--';
          },
          cellRenderer: (params) => {
              if (params.value != undefined && params.value != null) {
                return params.value;
              }
            },
        },
        {
          field: 'passed',
          headerName: this.gamesService.getGamesHistoryMessages('Player_Passed', 'Passed?'),
          cellRenderer: (params) => {
            if (params.value === undefined)
              return '';
        
            var approve = ' ';
            if (qualifierMetric) {
              approve = params.value ? '<svg class="icon-16 fill-emeraldCity"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
            } else {
              approve = '--';
            }
  
            return approve;
          },
          filterParams: {
            cellRenderer: (params) => {
              if (params.value === undefined)
                return '';
        
              var approve = ' ';
              if (qualifierMetric) {
                approve = JSON.parse(params.value.toLowerCase())  ? '<svg class="icon-16 fill-emeraldCity"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
              } else {
                approve = '--';
              }
              
              return approve;
            }
          }
        }]
      };
      if (qualifierMetric) resultsArray.push(qualifier);
    }

    let results = {
      headerName: " ",
      children: [
      {
        field: 'results',
        headerName: this.gamesService.getGamesHistoryMessages('Results', 'Results'),
        cellRenderer: (params) => {
          if(this.gs.selectedGame && this.gs.selectedGame[0]?.GameType == 9 && params.data.ruleObject) {
            return params.value;
          }
          
          if (typeof params.value === 'undefined')
            return '';

          if (!params.data.participant.AlreadyJoined)
            return params.value;

          if (this.gs.selectedGame && this.gs.selectedGame[0] && (this.gs.selectedGame[0].GameType == 6 || this.gs.selectedGame[0].GameType == 7)) {
            if (this.gs.selectedGame[0].Qualifier) {
              if (params.data.passed) {
                return '<span [ngbPopover]="connect3MetricsPopover" placement="left" triggers="outsideClick" container="body" class="color-cerulean">' + params.value + '</span>';
              } else {
                return params.value ? params.value : '';
              }
            } else if (params.value) {
              return '<span [ngbPopover]="connect3MetricsPopover" placement="left" triggers="outsideClick" container="body" class="color-cerulean">' + params.value + '</span>';
            }
          } else if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == 5) {
            if (this.gs.selectedGame[0].Qualifier) {
              if (params.data.passed) {
                return '<span class="color-cerulean">' + params.value + '</span>';
              } else {
                return params.value ? params.value : '';
              }
            } else if (params.value) {
              return '<span class="color-cerulean">' + params.value + '</span>';
            }
          } else if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == 10) {
              const span = document.createElement('span');

              span.innerText = params.value;
              span.className = 'color-cerulean cursor-pointer';
              span.addEventListener('click', (event) => this.openExpandedView(event, params));
              return span;
          } else {
            return params.value ? params.value : '';
          }
        }
      }]
    };

    //if multiplier madness, don't include results column
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].GameType != 1) {
      resultsArray.push(results);
    }

    const customRewards = (this.gs.selectedGame[0]?.GameType == 9 || this.gs.selectedGame[0]?.GameType == 10) ? [
      {
        field: 'custom',
        headerName: this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward'),
        minWidth: 175,
        cellRenderer: (params) => {
          if (params.value) {
            return params.value;
          }
          return '---';
        },
      }
    ] : [];

    let rewards = {
      headerName: this.gamesService.getGamesHistoryMessages('Reward', 'Reward'),
      children: [
      {
        field: 'calculatedCoins',
        headerName: this.gamesService.getGamesHistoryMessages('Coins', 'Coins'),
        filter: 'agNumberColumnFilter',
        cellRenderer: (params) => {
          let isTotalsRow = params.data.participant === undefined;

          if (!isTotalsRow)
            return params.value;
          else 
            return String(params.value) + this.displayReversionValue(this.revertedCoins) + this.gamesService.getGamesHistoryMessages('Coins', 'Coins');
        }
      },
      {
        field: 'calculatedXP',
        headerName: this.gamesService.getGamesHistoryMessages('XP', 'XP'),
        filter: 'agNumberColumnFilter',
        cellRenderer: (params) => {
          let isTotalsRow = params.data.participant === undefined;

          if (!isTotalsRow)
            return params.value;
          else 
            return String(params.value) + this.displayReversionValue(this.revertedXP) + this.gamesService.getGamesHistoryMessages('XP', 'XP');
        }
      },
      {
        field: 'badges',
        headerName: this.gamesService.getGamesHistoryMessages('Badges', 'Badges'),
        cellRenderer: (params) => {
          if (typeof params.value === 'undefined')
            return '---';

          if (params.value.length > 0) {
            let badge = '<img src="../Admin/ImageResizer.aspx?imgid=' + params.value[0] + '&w=26&h=26" class="img-fluid"/>';

            /*if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == 5 && params.value.length > 1) {
              badge += '<cv-milestone-badges-popover [badges]="data.badges"><span class="color-whaleTail lato-regular font-size-14">' + (params.value.length - 1) + '</span><cv-milestone-badges-popover/>';
            }*/

            return badge;
          } else if (typeof params.value === 'number') {
            //To display in totals row
            return params.value + " " + this.gamesService.getGamesHistoryMessages('Badges_Awarded', 'Badges Awarded');
          } else {
            return '---'
          }              
        },
        filterParams: {
          cellRenderer: (params) => {
            return params.value;
          }
        },
        sortable: false,
      },
      ...customRewards,
    ]
    };
    resultsArray.push(rewards);

    let payment = {
      headerName: this.gamesService.getGamesHistoryMessages('Payment', 'Payment'),
      children: [
        {
          field: 'paymentDate',
          headerName: this.gamesService.getGamesHistoryMessages('Payment_Info', 'Payment Information'),
          cellRenderer: (params) => { 
            if(params.data?.custom?.length > 0 && params.data?.productState >= 0){
              const orderStatus = PRODUCT_STATES[params.data.productState] || '---';
              return this.gamesService.getGamesHistoryMessages(orderStatus, orderStatus);
            }
            return params.value;
          },
          filterParams: {
            cellRenderer: (params) => { return params.value; }
          },
          sortable: true,
        }
      ]
    };

    resultsArray.push(payment);

    return resultsArray;
  }
    
  displayReversionValue(value: any): string {
    let resultRev: string = value != 0 ? " (" + value + ") " : " ";
    return resultRev;
  }

  // Bracket View
  openExpandedView(event: Event, params: any) {
    event.preventDefault();
    this.currentParticipant = this.gs.selectedGame[0].HistoryEligibility.AssignedGroups.emp.find(x => x.GroupID === params.data.participant.RelatedGroupID);
    this.currentParticipant.RoundNumber = params.data.resultsNumber;
    this.currentParticipant.isWinner = params.data.results === this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
    this.isExpandedView = true;
  }

  closeExpandedView(event: Event) {
    event.preventDefault();
    this.currentParticipant = null;
    this.isExpandedView = false;
  }

  get ruleName() {
    if (!this.hGame) return '';
    return this.hGame.RuleName;
  }

  get selectedMetrics() {
    if (!this.hGame) return [];
    const metric = this.hGame.metricDefinition;
    return [
      {
        ...metric,
        abbrev: metric?.MetricDetail?.Abbrev,
        metricID: metric?.MetricID,
      }
    ]
  }

  /**
   * Function to set the pinned data at the bottom of the grid.
   * @param participants - The participants data to be displayed in the bottom grid.
   */
  setPinnedData(participants: any[]): void {
    const sumPlayers = participants.reduce((sum, current) => sum + 1, 0);
    const sumCoins = participants.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
    const sumXP = participants.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
    const sumBadges = participants.reduce((sum, current) => sum + current.badges.length, 0);
    const sumCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && !a.isReverted).length;
    const sumRevertCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && a.isReverted).length;
    const revertedCustomRewards = sumRevertCustomRewards > 0 ? `(-${sumRevertCustomRewards})` : '';

    const pinnedData = [{
      participants: this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + sumPlayers,
      calculatedCoins: sumCoins,
      calculatedXP: sumXP,
      badges: sumBadges,
      custom: `${sumCustomRewards} ${revertedCustomRewards} ${this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward')}`,
    }];

    this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);
  }
}
